import { GenericMessage } from 'commons/interfaces'
import React, { Dispatch, SetStateAction } from 'react'
import { useState } from 'react'

export const InterceptorsContext = React.createContext<UseInterceptorsInterface>(
  {} as UseInterceptorsInterface
)

export interface ServerErrorModal {
  open: boolean
  title: string
}

export interface UseInterceptorsInterface {
  serverErrorModal: boolean
  setServerErrorModal: Dispatch<SetStateAction<boolean>>
  modalTitleErrorMessage: string
  setModalTitleErrorMessage: Dispatch<SetStateAction<string>>
  modalMessage: string
  setModalMessage: Dispatch<SetStateAction<string>>
  ErrorGenericMessage: GenericMessage
  timeoutTime: number
}

export const InterceptorsProvider: React.FC = ({ children }) => {
  const ErrorGenericMessage: GenericMessage = {
    title: 'Ocorreu um erro',
    message: 'Tente novamente mais tarde.'
  }
  const timeoutTime = 1000
  const [serverErrorModal, setServerErrorModal] = useState<boolean>(false)

  const [modalTitleErrorMessage, setModalTitleErrorMessage] = useState<string>('...')
  const [modalMessage, setModalMessage] = useState<string>('...')

  return (
    <>
      <InterceptorsContext.Provider
        value={{
          serverErrorModal,
          setServerErrorModal,
          modalTitleErrorMessage,
          setModalTitleErrorMessage,
          modalMessage,
          setModalMessage,
          ErrorGenericMessage,
          timeoutTime
        }}
      >
        {children}
      </InterceptorsContext.Provider>
    </>
  )
}
export const useInterceptors = () =>
  React.useContext<UseInterceptorsInterface>(InterceptorsContext)
